import {
  useMutation,
  useQueryClient,
  UseMutationOptions,
} from '@tanstack/react-query';

import {
  inviteProjectMembers,
  InviteProjectMembersInput,
} from '@/features/projects/shared/api/invite-project-members';
import { getProjectMembersQueryKey } from '@/features/projects/shared/hooks/use-project-members-query';
import { getProjectMemberManagementSearchKey } from '@/features/projects/shared/hooks/use-search-project-member-management';

type Props = Omit<
  UseMutationOptions<void, unknown, InviteProjectMembersInput>,
  'mutationFn'
>;

export const useInviteProjectMembersMutation = ({ ...props }: Props = {}) => {
  const queryClient = useQueryClient();

  return useMutation({
    ...props,
    mutationFn: inviteProjectMembers,
    onSuccess: async (data, variables, onMutateResult, context) => {
      await queryClient.invalidateQueries({
        queryKey: getProjectMemberManagementSearchKey({
          projectId: variables.projectId?.toString() || undefined,
        }),
      });
      await queryClient.invalidateQueries({
        queryKey: getProjectMembersQueryKey(variables.projectId.toString()),
      });
      props.onSuccess?.(data, variables, onMutateResult, context);
    },
  });
};
